import { gql } from '@apollo/client'

export const SEND_MESSAGE = gql`
  mutation SendMessage($request: ChatRequestDtoInput!) {
    chat {
      sendMessage(request: $request) {
        messageId
        conversationId
        content
        timestamp
        type
        isStreaming
        caseId
        userId
        documentList {
          fileName
          documentId
        }
      }
    }
  }
`
